import React from 'react';
import styled from 'styled-components';

interface Props {
  color: string;
  size?: number;
  className?: string;
  border?: boolean;
  children?: React.ReactNode;
}

const CssSphere = ({ color, size, className, border, children }: Props) => {
  return (
    <Sphere className={className ? className : ''} color={color} size={size} border={border}>
      {children}
    </Sphere>
  );
};

export default CssSphere;

const Sphere = styled.div<{ color: string; size?: number; border?: boolean }>`
  display: flex;
  align-self: center;
  height: ${({ size }) => (size ? size : 12)}px;
  width: ${({ size }) => (size ? size : 12)}px;
  background-color: ${({ color }) => color};
  border-radius: 50%;
  display: inline-block;
  ${({ border }) => border && 'border: 2px solid white;'}
`;
